<template>
  <v-container>
    <div class="hidden-sm-and-down">
      <v-data-table
        :headers="headers"
        :items="pedidosComIsBoletoVencido"
        item-key="bpdIntCod"
        :disable-pagination="true"
        class="elevation-1 mx-5 px-3 pb-3"
        @click:row="handleClick"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="font-weight-black">Pedidos</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="item.bpdStrBoletoUrl && item.isBoletoVencido === false"
            :href="item.bpdStrBoletoUrl"
            color="var(--vs-azul-primaria)"
            outlined
            target="_blank"
            class="font-weight-black"
            @click="dataVencimento(item)"
          >
            <v-icon class="pr-2">la-file-invoice-dollar</v-icon>GERAR BOLETO
          </v-btn>
        </template>
      </v-data-table>
    </div>

    <div class="hidden-md-and-up">
      <v-row
        class="white mx-2"
        style="border-bottom: 2px solid #BDBDBD !important;"
      >
        <v-col cols="12" lg="12" md="12" sm="12" class="d-flex align-center">
          <p
            class="text-left font-weight-black title grey--text text--darken-2 mb-0"
          >
            Pedidos
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-row align="center" justify="start" no-gutters class="pa-2">
          <template v-for="n in pedidos">
            <v-col :key="n.bpdIntCod" cols="6" class="pa-1">
              <v-card
                elevation="2"
                color="white"
                @click="handleClick(n)"
                style="border-radius: 4px !important;"
                height="190px"
              >
                <v-row class="fill-height flex-column">
                  <span
                    class="pt-4 pl-3 pb-0 subtitle-2 font-weight-regular black--text"
                    >Pedido número</span
                  >
                  <span
                    class="pl-3 pb-0 subtitle-1 font-weight-black black--text"
                    >{{ n.bpdIntCod }}</span
                  >

                  <v-col lg="12" md="12" sm="12" class="pa-0 pt-3 d-flex">
                    <!-- <span class="pl-3 pb-0 subtitle-2 font-weight-regular black--text">Data</span> -->
                    <div class="pl-3 pb-0 body-2 black--text font-weight-black">
                      {{ n.dataPedido }}
                    </div>
                  </v-col>

                  <v-col lg="12" md="12" sm="12" class="pa-0">
                    <span
                      class="pt-4 pl-3 pb-4 subtitle-2 font-weight-regular black--text"
                      >Status</span
                    >
                    <div
                      class="pl-3 pb-4 caption black--text font-weight-black"
                    >
                      {{ n.bpdStrStatusDescricao }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Número", value: "bpdIntCod" },
        { text: "Data", value: "dataPedido" },
        { text: "Status", value: "bpdStrStatusDescricao" },
        { text: "Ação", value: "action", sortable: false },
      ],
      loading: null,
      pedidosComIsBoletoVencido: null,
    };
  },
  methods: {
    dataVencimento(item) {
      let now = new Date();
      let seteDiasAtras = now.setDate(now.getDate() - 7);
      seteDiasAtras = new Date(seteDiasAtras).toISOString();

      if (item.bpdStrBoletoUrl) {
        if (seteDiasAtras > item.bpdDtmCriacao) {
          item.isBoletoVencido = true;
        } else {
          item.isBoletoVencido = false;
        }
      }
      this.pedidosComIsBoletoVencido = this.pedidos;
      return this.pedidosComIsBoletoVencido;
    },
    handleClick(pedido) {
      this.$store.dispatch("pedido/setPedido", pedido);
      this.$router.push({ name: "pedido" });
    },

    handleClickLoading(type) {
      this.loading = this.$vs.loading({
        type,
      });
    },
    hideLoading() {
      this.loading.close();
    },
    carregarPedidos(user) {
      this.handleClickLoading("waves");
      this.$store
        .dispatch("pedido/carregarPedidos", user)
        .then(() => {
          this.hideLoading();
        })
        .catch(() => {
          this.hideLoading();
        });
    },
  },
  // mounted() {
  //   if (this.user) {
  //     console.log("pedido/carregarPedidos", this.user);
  //     this.carregarPedidos(this.user);
  //   }
  // },
  created() {
    if (this.pedidos) {
      this.pedidos.forEach((el) => {
        el.isBoletoVencido = false;
        this.dataVencimento(el);
      });
      return this.pedidos;
    }
  },
  computed: {
    ...mapGetters({
      pedidos: "pedido/pedidos",
      user: "cliente/user",
      orcamento: "cliente/orcamento",
    }),
  },
};
</script>

<style>
.v-data-footer,
.v-data-table-header-mobile__wrapper {
  display: none;
}

.v-data-table tbody tr.expanded.expanded__content {
  box-shadow: none;
  background: #fafafa !important;
  margin-bottom: 4px !important;
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background: #e8f1f5;
}

.theme--light.v-data-table tbody tr.expanded.expanded__row {
  background: #e8f1f5;
}
</style>
